import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/onboarding/form/$locationId_/dashboard')({
  staticData: { team: 'fe-clm' },
});
